import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/default.png'


const _withScopeId = n => (_pushScopeId("data-v-13607742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-inner-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case-images" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = { class: "case-content" }
const _hoisted_4 = {
  key: 0,
  class: "case-title"
}
const _hoisted_5 = { class: "case-title-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "item-container",
    style: _normalizeStyle(_ctx.modelValue.style)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.count, (i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "case-item-box"
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.modelValue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ], 4))
}